module.exports = __webpack_public_path__ + "124f42907e0155500f26e160b4f81a46.MP3";